export type AppStateStatus = 'active' | 'background' | 'inactive' | 'unknown' | 'extension';
export const useAppState = (): AppStateStatus => 'active';
